@use '@fpsm/cxy-scss' as cxy;

.loaderContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--cxy-spacing-3);
}

.content {
  @include cxy.stack(var(--cxy-spacing-2));
}

.text {
  font-size: var(--cxy-fontSize-m);
  color: var(--cxy-color-content-default);
  text-align: center;
}
